import {DomainStore} from 'shared/store';
import { makeAutoObservable } from 'mobx';
import {endpoints, types} from 'main/tools';
import {NmbrEmployee} from 'main/stores/nmbr';

class NmbrPageState {
  store = new DomainStore();

  erroredNmbrEmployees = [];

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  async load() {
    await this.store._compose([
      endpoints.NMBR.EMPLOYEES.ERRORED
    ]);
    this.erroredNmbrEmployees = this.store._getAll(types.NMBR.EMPLOYEE, NmbrEmployee);
  }
}

export default NmbrPageState;
